// service-config-lint-disable: runtime-enriched-config-export-flow-covered -- this service is intentionally enriched at runtime, and the export flow already handles it as well.
import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { PlatformConfig, ServiceProvider } from '@wix/thunderbolt-symbols'
import { MultilingualDefinition as definition } from '@wix/viewer-service-multilingual/definition'
import { MultilingualService as impl } from '@wix/viewer-service-multilingual/implementations'
import { name } from './symbols'
import type { MultilingualServiceSiteConfig } from './types'
import { toMultilingualServiceConfig } from './config'

export const multilingualService = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(siteFeatureConfig: MultilingualServiceSiteConfig): ServiceProvider => {
		const config = toMultilingualServiceConfig(siteFeatureConfig)

		return {
			definition,
			impl,
			config,
			platformConfig: config as unknown as PlatformConfig,
		}
	}
)
